<template>
  <div class="element-popup" v-if="status.popup">
    <div class="container">
    <div class="popup-header">
      {{ label }}
      <p class="close" @click="clickClose()"></p>
    </div>

    <div class="popup-body">

      <div class="section-tab" v-if="!!subDescription" style="margin-top: 50px;">
        <div class="container">
          <div class="section-tab-header">
            <element-tab>
              <element-tab-item @click="popupHeaderTab = '자기신체손해'" :on="popupHeaderTab == '자기신체손해'">자기신체손해</element-tab-item>
              <element-tab-item @click="popupHeaderTab = '자동차상해'" :on="popupHeaderTab == '자동차상해'">자동차상해</element-tab-item>
            </element-tab>
          </div>
        </div>
      </div>

      <template v-if="!subDescription">
        <div class="section-radio">
          <div class="container">
            <element-content-radio @checkValue="checkValue" :subLabel="subLabel" :error="data.error" :label="data.label" :items="data.items[status.index].options" />
          </div>
        </div>
      </template>

      <template v-if="!!subDescription">
        <div class="section-radio">
          <div class="container">
            <element-content-radio
              @checkValue="checkValue"
              :subLabel="subLabel"
              :error="data.error"
              :label="data.label"
              :items="popupHeaderTab == '자기신체손해' ? data.items[status.index].options : data.items[status.index].subOptions"
              :popupHeaderTab="popupHeaderTab"
              :hasSubOptions="(subDescription != undefined)"
              />
          </div>
        </div>
      </template>

      <div class="section-tab">
        <div class="container">
          <div class="section-tab-header">
            <element-tab>
              <element-tab-item @click="popupTab = '상세설명'" :on="popupTab == '상세설명'">상세설명</element-tab-item>
              <element-tab-item @click="popupTab = '질문하기'" :on="popupTab == '질문하기'">질문하기</element-tab-item>
            </element-tab>
          </div>
        </div>

        <template v-if="!subDescription">
          <div class="body-item" v-if="popupTab == '상세설명'">
            <div class="container">
              <div v-for="item in description">
                {{ item.value }}
              </div>
            </div>
          </div>
        </template>

        <template v-if="!!subDescription">
          <div class="body-item" v-if="popupHeaderTab == '자기신체손해' && popupTab == '상세설명'">
            <div class="container">
              <div v-for="item in description">
                {{ item.value }}
              </div>
            </div>
          </div>

          <div class="body-item" v-if="popupHeaderTab == '자동차상해' && popupTab == '상세설명'">
            <div class="container">
              <div v-for="item in subDescription">
                {{ item.value }}
              </div>
            </div>
          </div>
        </template>


        <div class="body-item" v-if="popupTab == '질문하기'">
          <div class="container">
            <template id="tab-question">
              <label>{{ question.label }}</label>
              <element-textarea v-model="question.content.value" :error="question.content.error" :placeholder="question.content.placeholder" />
              <element-textbox v-model="question.phone.value" :error="question.phone.error" :placeholder="question.phone.placeholder" />
              <element-textbox v-model="question.email.value" :error="question.email.error" :placeholder="question.email.placeholder" />
              <button @click="submitQuestion">보내기</button>
              <element-confirm />
            </template>
          </div>
        </div>
      </div>
    </div>

    <div class="popup-bottom">
      <button @click="clickClose()">확인</button>
    </div>
    <slot />
  </div>
  </div>
</template>

<style lang="scss">

</style>

<script>
import Vue from "vue";

export default {
  props: [ "value", "data", "description", "statusPopup", "label", "subLabel", "subDescription", "process_title" ],
  data(){
    return {
      status: this.statusPopup,
      popupTab: '상세설명',
      popupHeaderTab: '자기신체손해',

      question: {
        label: "질문하기",
        content: {
          value: "",
          error: "",
          placeholder: "특별히 보장 받고 싶은 보장 항목, 기간, 금액 또는 현재 가입 중인 보험 그리고 상담 전 남기실 말씀을 입력하십시오. (200자 이내)",
        },
        phone: {
          value: "",
          error: "",
          placeholder: "답변 받을 휴대폰 번호"
        },
        email: {
          value: "",
          error: "",
          placeholder: "답변 받을 이메일 주소",
        }
      }
    }
  },
  computed: {
    model: {
      get(){
        return this.value;
      },
      set( value ){
        if(!!this.subDescription){
          value = this.popupHeaderTab;
        }
        this.$emit( "input", value );
      }
    }
  },
  updated() {
    this.calcHeight()
  },
  created () {
    this.$store.commit( "SET_DIMMER", true );
  },
  mounted() {
    this.calcHeight()
  },
  beforeDestroy() {
    this.clearHeight()
  },
  methods: {
    calcHeight() {
      this.clearHeight()
      var main = document.querySelector(".element-processor > main")
      var footer = document.querySelector(".element-processor > footer")

      var pop_body = document.querySelector(".element-processor .popup-body")
      var pop_footer = document.querySelector(".element-processor .popup-bottom")

      if(main && footer && pop_body && pop_footer){
        var ps_h = main.offsetHeight + footer.offsetHeight
        var pop_h = pop_body.offsetHeight + pop_body.offsetTop + pop_footer.offsetHeight
        document.querySelector(".element-processor").style.height = document.querySelector(".element-processor").offsetHeight + pop_h - ps_h + "px"
      }
    },
    clearHeight(){
      document.querySelector(".element-processor").style.height = null;
    },
    clickClose() {

      this.$store.commit( "SET_DIMMER", false );
      this.status.popup = !this.status.popup;
      this.$emit( 'status', this.status );

    },
    checkValue: function( value ){
      this.$emit( "checkPopup", value);
    },
    submitQuestion() {
      var param = {
        qnaText: this.question.content.value,
        phone: this.question.phone.value,
        email: this.question.email.value
      }
      if(!this.question.content.value) {
        this.question.content.error = "필수항목입니다"
      }else{
        this.question.content.error = ""
      }
      if(!this.question.phone.value){ this.question.phone.error = "필수항목입니다"}else{
        this.question.phone.error = ""
      }
      if(!this.question.email.value){ this.question.email.error = "필수항목입니다"}else{
        this.question.email.error = ""
      }
      if(!this.question.content.value || !this.question.phone.value || !this.question.email.value) return;

      //this.$store.dispatch( "etc/updateItems", { data: param } );
      var settings = {
        "async": true,
        "crossDomain": true,
        "url": "https://asia-northeast1-qprice-db76b.cloudfunctions.net/email_web",
        "method": "POST",
        "headers": {
          "content-type": "application/x-www-form-urlencoded",
          "cache-control": "no-cache"
        },
        "data": {
          "from": "cs@insunetfc.com",
          "to": "qna@insunetfc.com",
          "subject": `[고객문의] ${this.question.phone.value}(${this.question.email.value})`,
          "text": `[${this.process_title} - ${this.label}] 페이지에서 질문하기가 접수되었습니다.\n내용:\n\n${this.question.content.value}`,
          }
        }
      // Vue.axios.post("https://asia-northeast1-qprice-db76b.cloudfunctions.net/email_web", {
      //     "from": "cs@insunetfc.com",
      //     "to": "qna@insunetfc.com",
      //     "subject": `[고객문의] ${this.question.phone.value}(${this.question.email.value})`,
      //     "text": `[${this.process_title} - ${this.label}] 페이지에서 질문하기가 접수되었습니다.\n내용:\n\n${this.question.content.value}`,
      //     }).then( res => { })
      // .catch( response => {  } );



      this.$store.dispatch( "etc/sendEmail", { settings: settings} ).then( res => {});



      alert("질문이 전송되었습니다.")
    }
  }
}
</script>
